"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M6.354 5.646a.5.5 0 1 0-.708.708L11.293 12l-5.647 5.647a.5.5 0 1 0 .708.707L12 12.707l5.646 5.647a.5.5 0 0 0 .707-.708L12.708 12l5.647-5.646a.5.5 0 1 0-.708-.708L12 11.293z"
}), 'Clear');
